// extracted by mini-css-extract-plugin
export default {"skel":"Lgukg27rEn_Hyd94Gmui","bar":"Tf2Iby5FrBzch2Oc5bvk","tab":"eCQ3bs9PdC2vxcdhWHwY","view":"KydpPwUUpvFLt8DtatNc"};